// Utilidades de red para detectar conectividad.
export const isOnline = () => {
  if (typeof navigator === "undefined") return true;
  return navigator.onLine;
};

export const onOnline = (callback) => {
  window.addEventListener("online", callback);
};

export const onOffline = (callback) => {
  window.addEventListener("offline", callback);
};
